import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const updateActionItemMutation = loader(
  'src/components/modals/ActionItemModal.updateActionItem.graphql',
);
const addParticipantToActionItemMutation = loader(
  'src/components/modals/ActionItemModal.addParticipant.graphql',
);
export const useActionItem = () => {
  const [updateActionItemMut] = useMutation(updateActionItemMutation);
  const [addParticipantMutation] = useMutation(
    addParticipantToActionItemMutation,
  );

  const updateActionItem = async ({
    actionItemId,
    status,
    outcome,
    locked,
    onComplete = () => {},
  }) => {
    await updateActionItemMut({
      variables: { id: actionItemId, status, outcome, locked },
    }).then(() => onComplete());
  };
  const addParticipant = async ({
    userId,
    actionItemId,
    onComplete = () => {},
  }) =>
    await addParticipantMutation({ variables: { actionItemId, userId } }).then(
      () => onComplete(),
    );
  return {
    updateActionItem,
    addParticipant,
  };
};
